import React from 'react';

const ConstructionPage = () => {
  return (
    <div>
      <h1>Construction</h1>
    </div>
  );
};

export default ConstructionPage;
